export default __webpack_public_path__ + "static/media/DONATE-NOW.64609fa1.png";